import { LogLevel } from "@azure/msal-browser"

/**
 * Configuration object to be passed to MSAL instance on creation.
 * For a full list of MSAL.js configuration parameters, visit:
 * https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-browser/docs/configuration.md
 */
export const msalConfig = {
  auth: {
    clientId: process.env.GATSBY_AZURE_CLIENT_ID,
    authority: process.env.GATSBY_AZURE_AUTHORITY, // Your tenant ID
    redirectUri:
      process.env.GATSBY_REDIRECT_URI ||
      (typeof window !== "undefined" ? window.location.origin : undefined),
    postLogoutRedirectUri:
      process.env.GATSBY_POST_LOGOUT_REDIRECT_URI ||
      (typeof window !== "undefined" ? window.location.origin : undefined),
    navigateToLoginRequestUrl: false, // If "true", will navigate back to the original request location before processing the auth code response.
  },
  cache: {
    cacheLocation: "sessionStorage", // Configures cache location. "sessionStorage" is more secure, but "localStorage" gives you SSO between tabs.
    storeAuthStateInCookie: false, // Set to true if you are having issues on IE11 or Edge
    secureCookies: false, // Set to true if your application is using https
  },
  system: {
    loggerOptions: {
      loggerCallback: (level, message, containsPii) => {
        if (containsPii) {
          return
        }
        switch (level) {
          case LogLevel.Error:
            console.error(message)
            return
          case LogLevel.Info:
            console.info(message)
            return
          case LogLevel.Verbose:
            console.debug(message)
            return
          case LogLevel.Warning:
            console.warn(message)
            return
          default:
            return
        }
      },
    },
  },
}

/**
 * Scopes you add here will be prompted for user consent during sign-in.
 * By default, MSAL.js will add OIDC scopes (openid, profile, email) to any login request.
 * For more information about OIDC scopes, visit:
 * https://docs.microsoft.com/en-us/azure/active-directory/develop/v2-permissions-and-consent#openid-connect-scopes
 */
export const loginRequest = {
  scopes: ["User.Read"],
}

/**
 * Add here the scopes to request when obtaining an access token for MS Graph API. For more information, see:
 * https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-browser/docs/resources-and-scopes.md
 */
export const graphConfig = {
  graphMeEndpoint: "https://graph.microsoft.com/v1.0/me",
  graphUsersEndpoint: "https://graph.microsoft.com/v1.0/users",
}

/**
 * Define the scopes here for API
 */
export const protectedResources = {
  graphMe: {
    endpoint: graphConfig.graphMeEndpoint,
    scopes: ["User.Read"],
  },
  graphUsers: {
    endpoint: graphConfig.graphUsersEndpoint,
    scopes: ["User.Read.All"],
  },
}

/**
 * Environment variables to set in your .env files:
 *
 * For Development (.env.development):
 * GATSBY_AZURE_CLIENT_ID=your-client-id
 * GATSBY_REDIRECT_URI=http://localhost:8000/
 * GATSBY_POST_LOGOUT_REDIRECT_URI=http://localhost:8000/
 *
 * For Production (.env.production):
 * GATSBY_AZURE_CLIENT_ID=your-client-id
 * GATSBY_REDIRECT_URI=https://your-production-domain.com/
 * GATSBY_POST_LOGOUT_REDIRECT_URI=https://your-production-domain.com/
 */
